import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
import axios from 'axios'

export const sendEmailInteractive = async (id, email) => {
    const response = await axios(
        `${PRESUPUESTADOR_ENDPOINT}/${id}/interactive/advisor/mail?email=${email}`
    )
    return response;
}
